import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PawPrint } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export const HomePetOfTheWeek = () => {
  const [pet, setPet] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/pet-photos`)
      .then((r) => r.json())
      .then((d) => setPet(d.featured || null))
      .catch(() => {});
  }, []);

  if (!pet) return null;

  return (
    <section data-testid="home-pet-of-the-week" className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="grid md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-10 md:gap-14 items-center border border-emerald/10 rounded-[28px] bg-sand p-7 md:p-12"
      >
        <div className="relative">
          <span
            data-testid="home-pet-badge"
            className="absolute -top-3 left-5 z-10 bg-sunset text-cream text-[11px] font-semibold uppercase tracking-[0.14em] px-3 py-1 rounded-full shadow-sm"
          >
            Pet of the week
          </span>
          <img
            src={`${API}${pet.image_url}`}
            alt={`${pet.pet_names}, Pet of the Week at Double Rainbow Suites`}
            loading="lazy"
            className="w-full aspect-square object-cover rounded-2xl"
          />
        </div>
        <div>
          <p className="overline text-sunset mb-5 flex items-center gap-2">
            <PawPrint size={16} weight="duotone" /> Fresh from the guest gallery
          </p>
          {pet.comment && (
            <blockquote data-testid="home-pet-quote" className="font-display text-2xl md:text-4xl leading-snug text-emerald mb-6">
              "{pet.comment}"
            </blockquote>
          )}
          <p className="text-sm text-emerald-soft mb-8">
            <span className="font-medium text-emerald">{pet.pet_names}</span>
            <span className="text-emerald-soft/70"> · shared by {pet.uploader_name}</span>
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <Link
              to="/fort-lauderdale-pet-friendly-vacation-rentals"
              data-testid="home-pet-gallery-link"
              className="text-sm font-medium text-sunset hover:text-emerald transition-colors duration-300"
            >
              Meet all our four-legged guests →
            </Link>
            <Link
              to="/pet-photo-upload"
              data-testid="home-pet-share-link"
              className="text-sm font-medium text-emerald-soft hover:text-sunset transition-colors duration-300"
            >
              Share your pet's photo →
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
};
